import React from 'react'
import { withTranslation } from 'react-i18next'
import hoistNonReactStatics from 'hoist-non-react-statics' // 已作为间接依赖引入，减少对原工程修改，不单独声明依赖
import { I18nInternalContext } from './internal/I18nInternalContext'
import {
  EXTERNAL_REGISTER_RESOURCE_MAP,
  I18N_LOADING_COUNT,
} from './internal/I18nConst'

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]'
}

// 早期实现使用 uuid 库的 v4 生成 uuid，实际此场景不需要
function fakeUuid() {
  return new Date().getTime().toString(36) + Math.random().toString(36).slice(2)
}

function getNameSpace(arg1, arg2) {
  let namespace, resourceMap
  if (isObject(arg1)) {
    // (resourceMap)
    resourceMap = arg1
    namespace = fakeUuid()
  } else if (typeof arg1 === 'string' && isObject(arg2)) {
    // (namespace, resourceMap)
    namespace = arg1
    resourceMap = arg2
  } else {
    throw new Error('please check withI18n arguments...')
  }
  return [namespace, resourceMap]
}

// 支持通过 namespace 指定页面所需的语言包
export function withI18n() {
  const [namespace, resourceMap] = getNameSpace(...arguments)
  const withFunc = withTranslation(namespace)
  return function wrap(Component) {
    // 不能确定 Component 是页面还是单个组件

    // 对于页面，在 getInitialProps 注入，并等待语言包加载完成
    const ref = Component.getInitialProps
    Component.getInitialProps = async function (ctx) {
      const i18n = ctx.i18n
      i18n[EXTERNAL_REGISTER_RESOURCE_MAP](namespace, resourceMap)
      const [refResult] = await Promise.all([
        ref && (await ref.call(Component, ctx)),
        new Promise((resolve) => i18n.loadNamespaces(namespace, resolve)),
      ])
      return refResult || {}
    }

    // 对于普通组件，则在构造上注入语言包，加载语言包但不阻塞
    class AlExWithNamespacedI18n extends React.PureComponent {
      static displayName = `alExWithNamespacedI18n(${
        Component.displayName || Component.name || 'Component'
      })`

      constructor(props, ...rest) {
        super(props, ...rest)
        props.i18n[EXTERNAL_REGISTER_RESOURCE_MAP](namespace, resourceMap)
        props.i18n.loadNamespaces(namespace)

        this.state = {
          i18nInternalContext: {
            namespace,
            isI18nResourceLoading: props.i18n[I18N_LOADING_COUNT],
          },
        }
      }

      render() {
        return (
          <I18nInternalContext.Provider value={this.state.i18nInternalContext}>
            <Component {...this.props} />
          </I18nInternalContext.Provider>
        )
      }
    }

    hoistNonReactStatics(AlExWithNamespacedI18n, Component)

    // HACK 未知原因，withFunc 后丢失 getInitialProps，手动恢复
    const result = withFunc(AlExWithNamespacedI18n)
    result.getInitialProps = Component.getInitialProps
    return result
  }
}
